var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "32px",
    height: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#f32f28",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(16,16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.49609,1c-0.82081,0 -1.49609,0.67528 -1.49609,1.49609v0.50391h-3v1h1v8.5c0,0.82253 0.67747,1.5 1.5,1.5h6c0.82253,0 1.5,-0.67747 1.5,-1.5v-8.5h1v-1h-3v-0.50391c0,-0.82081 -0.67528,-1.49609 -1.49609,-1.49609zM6.49609,2h2.00781c0.28119,0 0.49609,0.21491 0.49609,0.49609v0.50391h-3v-0.50391c0,-0.28119 0.21491,-0.49609 0.49609,-0.49609zM4,4h1h1h3h1h1v8.5c0,0.28147 -0.21853,0.5 -0.5,0.5h-6c-0.28147,0 -0.5,-0.21853 -0.5,-0.5zM5,5v7h1v-7zM7,5v7h1v-7zM9,5v7h1v-7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.a2d83f2d71deb783f25f59e9c1f2b027.svg";
export { ForwardRef as ReactComponent };